export class GitProviderFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<GitProvider>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<GitProvider>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitProviderFilters.attributeTypeMap;
    }
    constructor() {
    }
}
